import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, Paper, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { gridSpacing } from 'utils/constants';
import MainCard from 'components/Cards/MainCard';
import ApiHelper from 'utils/apiHelper';
import { toast } from 'react-toastify';
import ReportFileExports from 'components/Reports/FileExports';
import ReportVisualization from 'components/Reports/ReportVisualization';

const ReportsGroupSummary = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [groupSummaryData, setGroupSummaryData] = useState([]);
    const [filters, setFilters] = useState({});

    useEffect(() => {
        getGroupSummaryData();
    }, []);

    const getGroupSummaryData = () => {
        setLoading(true);
        ApiHelper.get('/api/reports/group_summary/')
            .then((res) => {
                setGroupSummaryData(res.data);
                setLoading(false);
                setFilters({
                    report: 'Group Summary',
                    filterData: []
                });
            })
            .catch((err) => {
                if (err.response.status !== 401) {
                    setLoading(false);
                    toast.warning('There is no group summary data');
                }
            });
    };

    return (
        <MainCard title="Operational Reports Management" cardHeaderTitle="Group Summary" cardHeaderShow={true}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={10}>
                    <Typography sx={{ fontSize: '16px' }}>Lists the groups in use and the number of devices in each group</Typography>
                </Grid>
                {groupSummaryData.length > 0 && (
                    <Grid item xs={2}>
                        <ReportFileExports
                            downloadFileName="group_summary"
                            downloadFileOption="all"
                            data={groupSummaryData}
                            headers={[
                                { label: 'Group Name', key: 'group_name' },
                                { label: 'Devices in Group', key: 'devices_in_group' },
                                { label: 'Group Description', key: 'group_description' }
                            ]}
                            filters={filters}
                            setExportLoading={setExportLoading}
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <ReportVisualization
                        loading={loading}
                        data={groupSummaryData}
                        type="table"
                        tableHeaders={['Group Name', 'Devices in Group', 'Group Description']}
                        tableData={groupSummaryData.map((data) => [data.group_name, data.devices_in_group, data.group_description])}
                    />
                </Grid>
            </Grid>
            {exportLoading === true ? (
                <div className="overlayStyle">
                    <div className="spinner spinnerStyle"></div>
                </div>
            ) : null}
        </MainCard>
    );
};

export default ReportsGroupSummary;
